
const NotesBanner = () => {
  return (
    <div className="alert alert-warning py-1 mt-1">
      <div className='d-flex align-items-center'>
        <div className='flex-grow-0 me-2'>
          <i className="fa fa-exclamation-circle text-danger" />
        </div>
        <div className='flex-grow-0'>
          Notes should not contain Billing, Shipping, or Manufacturing related notes.
        </div>
      </div>
    </div>
  );
};
export { NotesBanner };

